var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__sort_button"},[_c('component-button',{attrs:{"name":'filter-sort-button-switch',"icon":true,"icon-name":'chevron-down',"icon-raw":true},on:{"click":function($event){return _vm.$emit('switch-menu')}}},[_vm._v(_vm._s(_vm.$t('filter.sort.buttonSortBy')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }